module.exports = __webpack_public_path__ + "assets/media/evening.473df87d.mp3";